'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('react-select/dist/react-select.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Select = function Select(_ref) {
  var options = _ref.options,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['options', 'className', 'onChange']);

  var handleChange = function handleChange(val) {
    var value = (0, _lodash.isArray)(val) ? (0, _lodash.map)(val, 'value') : val && val.value;
    onChange && onChange(value);
  };

  return _react2.default.createElement(_reactSelect2.default, _extends({}, props, {
    className: 'Select ' + className,
    options: options,
    onChange: handleChange
  }));
};
exports.default = Select;